import { render, staticRenderFns } from "./IncomingInvoiceListItemActions.vue?vue&type=template&id=28d87fa5&scoped=true&"
import script from "./IncomingInvoiceListItemActions.vue?vue&type=script&lang=ts&"
export * from "./IncomingInvoiceListItemActions.vue?vue&type=script&lang=ts&"
import style0 from "./IncomingInvoiceListItemActions.vue?vue&type=style&index=0&id=28d87fa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d87fa5",
  null
  
)

export default component.exports